import { useEffect, useState } from "react";
import { PixSection } from "./_PixSection";
import { BankSlipSection } from "./_BankSlipSection";
import { CredicardSection } from "./_CreditCardSection";
import { ChangeHistoriySection } from "./_ChangeHistoriySection";
import { Button, Divider, Flex } from "@chakra-ui/react";
import { ObservationTextSection } from "./_ObservationTextSection";
import { DiscardChangesModal } from "./modal/discardChangesModal";
import { ReviewModal } from "./modal/reviewModal";
import { adjustResponse, adjustNewResponse, invertRatesStructure, reverseAdjustNewResponse, adjustResponseRepasse } from "./utils/functions";
import { useTaxes } from "../../contexts/TaxV2Context";


export function TransactionalCostsV2(
) {
  const [observationText, setObservationText] = useState<string>("");
  const [organizateRateOld, setOrganizateRateOld] = useState();
  const [organizateRateNew, setOrganizateRateNew] = useState();
  const [resetTrigger, setResetTrigger] = useState(0);
  const [organizateRateReviewPixNew, setOrganizateRateReviewPixNew] = useState({})
  const [organizateRateReviewPixOld, setOrganizateRateReviewPixOld] = useState({})
  const [organizateRateReviewNewCard, setOrganizateRateReviewNewCard] = useState({})
  const [organizateRateReviewOldCard, setOrganizateRateReviewOldCard] = useState({})
  const [organizateRateReviewBankSlipOld, setOrganizateRateReviewBankSlipOld] = useState({})
  const [organizateRateReviewBankSlipNew, setOrganizateRateReviewBankSlipNew] = useState({})
  const [organizateRateReviewCreditCardOld, setOrganizateRateReviewCreditCardOld] = useState({})
  const [organizateRateReviewCreditCardNew, setOrganizateRateReviewCreditCardNew] = useState({})
  const [limitLenghtHistory, setLimitLenghtHistory] = useState<number>(3)
  const [updatePage, setUpdatePage] = useState<boolean>(false)


  const [onEdit, setOnEdit] = useState<Boolean>(false)
  const { fetchRateBrands,
    fetchRateSeller,
    sellerRates,
    fetchHistorySeller,
  } = useTaxes();


  useEffect(() => {
    fetchRateBrands();
    fetchRateSeller();
    fetchHistorySeller(1, limitLenghtHistory);
    // eslint-disable-next-line
  }, []);


  useEffect(() => {
    if (updatePage === true) {
      try {
        fetchRateBrands();
        fetchRateSeller();
        fetchHistorySeller(1, limitLenghtHistory);

      } catch (error) {
        console.log(error)
      } finally {

        setUpdatePage(false)
        setResetTrigger(prev => prev + 1)
      }
    }
    // eslint-disable-next-line
  }, [updatePage]);


  useEffect(() => {
    if (limitLenghtHistory !== 5) {

      fetchHistorySeller(1, limitLenghtHistory);
    }
    // eslint-disable-next-line
  }, [limitLenghtHistory]);




  function buildComponent(data, origin) {
    const organizedRatesOld = adjustResponse(data.oldRates, origin)
    const organizedRatesNew = adjustResponse(data.newRates, origin)
    const organizedRatesDayOld = adjustResponseRepasse(data.oldRates, origin)
    const organizedRatesDayNew = adjustResponseRepasse(data.newRates, origin)
    if (origin === "PIX") {
      setOrganizateRateReviewPixNew({ organizedRatesNew, organizedRatesDayNew });
      setOrganizateRateReviewPixOld({ organizedRatesOld, organizedRatesDayOld });
    }
    if (origin === "BANK_SLIP") {
      setOrganizateRateReviewBankSlipNew({ organizedRatesNew, organizedRatesDayNew });
      setOrganizateRateReviewBankSlipOld({ organizedRatesOld, organizedRatesDayOld });
    }
    if (origin === "CREDIT_CARD_EARLY_SELLER") {
      setOrganizateRateReviewCreditCardNew({ organizedRatesNew, organizedRatesDayNew });
      setOrganizateRateReviewCreditCardOld({ organizedRatesOld, organizedRatesDayOld });
      setOrganizateRateReviewNewCard(invertRatesStructure(adjustResponse(data.newRates, "CREDIT_CARD_EARLY_SELLER")))
      setOrganizateRateReviewOldCard(invertRatesStructure(adjustResponse(data.oldRates, "CREDIT_CARD_EARLY_SELLER")))
    }
  }

  useEffect(() => {
    if (organizateRateOld && organizateRateNew) {
      buildComponent({ oldRates: reverseAdjustNewResponse(organizateRateOld), newRates: reverseAdjustNewResponse(organizateRateNew) }, "CREDIT_CARD_EARLY_SELLER");
      buildComponent({ oldRates: reverseAdjustNewResponse(organizateRateOld), newRates: reverseAdjustNewResponse(organizateRateNew) }, "PIX");
      buildComponent({ oldRates: reverseAdjustNewResponse(organizateRateOld), newRates: reverseAdjustNewResponse(organizateRateNew) }, "BANK_SLIP");
    }
    // eslint-disable-next-line
  }, [organizateRateOld, organizateRateNew,resetTrigger]);


  useEffect(() => {

    if (sellerRates) {
      setOrganizateRateNew(adjustNewResponse(sellerRates));
      setOrganizateRateOld(adjustNewResponse(sellerRates));
    }
    // eslint-disable-next-line
  }, [sellerRates,resetTrigger]);

  return (
    <Flex flexDirection="column" gap="32px" >
      {onEdit === true ?
        <Flex gap="28px"
          justifyContent="end"
        // mt="-55px"
        // zIndex={999}
        >
          {/* <ResetTaxModal setOnEdit={setOnEdit} /> */}
          <DiscardChangesModal
            setResetTrigger={setResetTrigger}
            resetTrigger={resetTrigger}
            setOnEdit={setOnEdit}
            onEdit={onEdit}

          />

          <ReviewModal
            observationText={observationText}
            setObservationText={setObservationText}
            organizateRateOld={organizateRateOld}
            organizateRateNew={organizateRateNew}
            setResetTrigger={setResetTrigger}
            resetTrigger={resetTrigger}
            isHistory={false}
            creditCardOldRates={organizateRateReviewOldCard}
            creditCardNewRates={organizateRateReviewNewCard}
            organizateRateReviewPixNew={organizateRateReviewPixNew}
            organizateRateReviewPixOld={organizateRateReviewPixOld}
            organizateRateReviewBankSlipOld={organizateRateReviewBankSlipOld}
            organizateRateReviewBankSlipNew={organizateRateReviewBankSlipNew}
            organizateRateReviewCreditCardOld={organizateRateReviewCreditCardOld}
            organizateRateReviewCreditCardNew={organizateRateReviewCreditCardNew}
            setUpdatePage={setUpdatePage}
          />
        </Flex>
        :
        <Flex
          w="100%"
          justifyContent="end"
        // mt="-55px"
        // zIndex={9999}
        >
          <Button
            onClick={() => setOnEdit(true)}
            variant="outline"
            w="73px"
            h="32px"
          >
            Editar
          </Button>
        </Flex>
      }



      <PixSection
        organizateRateOld={organizateRateOld}
        setOrganizateRateNew={setOrganizateRateNew}
        resetTrigger={resetTrigger}
        onEdit={onEdit}
      />
      <Divider />
      <BankSlipSection
        organizateRateOld={organizateRateOld}
        setOrganizateRateNew={setOrganizateRateNew}
        resetTrigger={resetTrigger}
        onEdit={onEdit}
      />
      <Divider />
      <CredicardSection
        organizateRateOld={organizateRateOld}
        organizateRateNew={organizateRateNew}
        setOrganizateRateNew={setOrganizateRateNew}
        resetTrigger={resetTrigger}
        onEdit={onEdit}
      />
      <Divider />
      <ObservationTextSection
        onEdit={onEdit}
        observationText={observationText}
        setObservationText={setObservationText}
      />
      <ChangeHistoriySection
        setLimit={setLimitLenghtHistory}
        limit={limitLenghtHistory}
        setObservationText={setObservationText}
      />

    </Flex>
  )
}

